import React from "react";
import { Box } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import { Section } from ".";
import "../styles/index.scss";
import { en } from "../content";

function Welcome({ isMobile }) {
  const content = en.about;

  return (
    <Box
      className="welcome"
      top={0}
      position={isMobile ? "relative" : "sticky"}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Section>
        <Box className="greeting typing">
          <Box className="line">{content.greetings}</Box>
          <Box className="line">{content.greetingsName}</Box>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          position="absolute"
          left={0}
          right={0}
          bottom={20}
        >
          <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: 30 }} />
        </Box>
      </Section>
    </Box>
  );
}

export default Welcome;
